<template>
<div :class="[
    $style.block,
    settings.orientation === 'right' ? $style.reversed : '']">
  <div
    :class="[
      $style.background,
      settings.background === 'right' ? $style.right : ''
    ]"
    style="transform: scaleY(0.00001);"
    data-anim="mask"
  ></div>

  <figure :class="[$style.container]">

    <figcaption :class="$style.textContent">
      <TextBlock
        :content="content.text"
        :reversed="settings.orientation === 'right'"
        :title="content.title"
        :class="$style.textBlock"
        />

      <div
        :class="[$style.iconsList, $route.name === 'experience' ? $style.couple : '']"
        v-if="content.icons"
        data-anim="staggerImg"
      >
        <img
          v-for="(icon, index) in content.icons"
          :key="index"
          :src="icon.url"
          :alt="icon.alt"
        >
      </div>
    </figcaption>

    <!-- Parallax switcher -->
    <Parallax v-if="settings.parallax" :images="content.images"  />
    <div
      v-else
      :data-anim="$store.state.route.name === 'experience' && content.images.length > 1 ? false : 'parallax'"
      :class="[$style.parallaxContainer, settings.enableEnter ? $style.enableEnter : '']">
      <div
        v-for="(image, i) in content.images"
        :key="image"
        v-lazy:background-image="image"
        :data-anim="$store.state.route.name === 'experience' && content.images.length > 1 ? 'parallax' : false"
        :data-parallax="`${(i - 1.5) / 20}`"
        :class="[$style.parallax, settings.align === 'right' ? $style.right : false]"></div>
    </div>
  </figure>
</div>
</template>

<script>
import TextBlock from '@/components/TextBlock'
import Parallax from '@/components/Parallax'

export default {
  props: ['content', 'settings'],
  components: {
    TextBlock,
    Parallax
  }
}
</script>

<style module lang="scss">
@import "~sass-mq/mq";

.block {
  position: relative;

  &.reversed {
    @include mq(sm) {
      .container {
        flex-flow: row-reverse;
        padding-right: $big-margin;
        padding-left: 0;
      }
    }
  }
}

.container {
  @include grid-size();
  display: flex;
  flex-flow: column;
  padding: $big-margin-mobile;
  perspective: 1000px;

  @include mq(sm) {
    flex-flow: row;
    justify-content: space-between;
    padding: ($big-margin * 2) 0;
    padding-left: $big-margin;
  }
}

.background {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 60%;
  height: 100%;
  background-color: $color-dark-two;
  z-index: -1;

  @include mq(sm) {
    display: block;
  }

  &.right {
    left: auto;
    right: 0;
  }
}

.textContent {
  display: flex;
  flex: 0 1 auto;
  width: 100%;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: $standard-margin-mobile;

  @include mq(sm) {
    width: 45%;
    flex-flow: column;
  }

  @include mq(ds) {
    width: 30%;
  }
}

.textBlock {
  width: 100%;
  flex: 0 0 100%;

  @include mq(sm) {
    width: 100%;
    flex: auto;
  }
}

.imageContainer.enableEnter,
.parallaxContainer.enableEnter {
  perspective: 1000px;
}

.parallaxContainer {
  position: relative;
  flex: 0 0 auto;
  overflow: hidden;

  @include mq(sm) {
    width: 50%;

    min-height: 470px;
  }

  @include mq(ds) {
    width: 60%;
    min-height: none;
  }

  &:before {
    content: "";
    display: block;
    width: 100%;
    padding-bottom: 80%;
  }

  .parallax {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    &.right {
      background-position: 0 50%;
    }
  }
}

.enableEnter [lazy] {
  transition: all 1.5s cubic-bezier(.29,.67,0,1) 0.2s;
}

.enableEnter [lazy=loading] {
  transform: translate3d(0, 200px, 100px);
  clip-path: inset(100% 0 0 0);
  -webkit-clip-path: inset(100% 0 0 0);
  backface-visibility: hidden;
}

.enableEnter [lazy=loaded] {
  transform: translate3d(0, 0, 0);
  clip-path: inset(0 0 0 0);
  -webkit-clip-path: inset(0 0 0 0);
  backface-visibility: hidden;
}


.parallaxContainer.enableEnter [lazy=loading] {
  transform: translate3d(0, 200px, 100px) scale(2);
}

.parallaxContainer.enableEnter [lazy=loaded] {
  transform: translate3d(0, 0, 0) scale(1);
}

.iconsList {
  margin-top: 40px;
  padding-left: 0px;

  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;

  width: 100%;
  flex: 0 0 100%;

  @include mq(sm) {
    margin-top: 80px;
    width: auto;
    flex: 1 0 auto;
    padding-left: 50px;
  }

  &.couple {
    justify-content: space-between;

    img {
      display: inline-block;
      flex: 0 0 40%;
      width: 40%;
      margin: 0 15% 20px 0;

      opacity: 0.7;

      max-height: 22px;
      margin: 0 0 20px;
      text-align: left;

      @include mq(sm) {
        max-height: 15px;
        margin: 0 0 30px;
      }
    }
  }

  img {
    display: inline-block;
    flex: 0 0 16%;
    width: 16%;
    margin: 0 14% 20px 0;

    opacity: 0.7;

    @include mq(sm) {
      flex: 0 0 20%;
      width: 20%;
      margin: 0 10% 20px 0;
    }


    @include mq(md) {
      flex: 0 0 15%;
      width: 15%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FigureBlock.vue